import { css } from '@emotion/react';
import { useSelectedLocation } from '@frontend/payments-hooks';
import { BuyNowPayLater } from '../../components/BuyNowPayLater/buy-now-pay-later';
import { PaymentsPage } from '../../components/PaymentsPage';

export const BNPLPanelLocationContextWrapper = () => {
  const locationId = useSelectedLocation();

  return (
    <PaymentsPage
      css={css`
        margin-bottom: 0;
      `}
    >
      <BuyNowPayLater locationId={locationId} />
    </PaymentsPage>
  );
};
